import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { GeminiProvider } from '@gemini/core';
import { IWT_THEME } from '@gemini/tokens';
import { ThemeProvider } from '@emotion/react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18next';
import { App } from './App';
createRoot(document.getElementById('root')).render(_jsx(StrictMode, { children: _jsx(GeminiProvider, { theme: IWT_THEME, children: _jsx(ThemeProvider, { theme: IWT_THEME, children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(App, {}) }) }) }) }));
